import { createCookie, readCookie } from './Cookie.js';
import getFingerPrint from './getFingerPrint.js';

function setInCookie(val) {
  const now = new Date();
  const time = now.getTime();
  const expireTime = time + 24 * 60 * 60 * 1000 * 365;
  now.setTime(expireTime);
  const { href = '' } = location;
  let domain = '';
  const domainToBeUSed = getDomain(href);
  if (domainToBeUSed) {
    domain = `.${domainToBeUSed}`;
  }
  // Add Secure flag for all environments except localhost
  const isLocalhost = typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
  const secureFlag = isLocalhost ? '' : '; Secure';
  document.cookie = `_fpuuid= ${val}; expires=${now.toGMTString()}; path=/; domain=${domain}${secureFlag}`;
  document.cookie = `deviceId= ${val}; expires=${now.toGMTString()}; path=/; domain=${domain}${secureFlag}`;
}
function getDomain(href) {
  const domainArr = ['ajio.com', 'ril.com'];
  for (let i = 0; i < domainArr.length; i++) {
    const domainToBeUSed = domainArr[i];
    if (href.toLowerCase().includes(domainToBeUSed)) {
      return domainToBeUSed;
    }
  }
  return '';
}

export const getFingerprint = () => {
  return new Promise(async resolve => {
    console.log('CHECK LOGIN FLOW - 666666666666666666');
    const result = await getFingerPrint();
    const id = result.nanoid();
    console.log('CHECK LOGIN FLOW - 777777777777777777777', id);
    if (id) {
      setInCookie(id);
      localStorage.setItem('_fpuuid', id);
    }
    return resolve(id);
    // Fingerprint2().get((result) => {
    //     if(result) {
    //       setInCookie(result);
    //       localStorage.setItem("_fpuuid", result);
    //     }
    //     return resolve(result);
    // });
  });
};

export const checkFingerPrintDetails = () => {
  const fp_cookie = readCookie('_fpuuid');
  const fp_lStore = localStorage.getItem('_fpuuid');
  console.log('CHECK LOGIN FLOW - 1111111111111111111111');
  if (!fp_cookie && fp_lStore) {
    console.log('CHECK LOGIN FLOW - 2222222222222222222222');
    setInCookie(fp_lStore);
    return Promise.resolve();
  }
  if (fp_cookie && !fp_lStore) {
    console.log('CHECK LOGIN FLOW - 33333333333333333333');
    localStorage.setItem('_fpuuid', fp_cookie);
    return Promise.resolve();
  }
  if (!fp_cookie && !fp_lStore) {
    console.log('CHECK LOGIN FLOW - 4444444444444444444444');
    return getFingerprint();
  }
  console.log('CHECK LOGIN FLOW - 555555555555555555555555');
  return Promise.resolve();
};
